import { enableProdMode } from '@angular/core';

import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { AppComponent } from './app/app.component';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { environment } from './environments/environment';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { provideAnimations } from '@angular/platform-browser/animations';

if (environment.production) {
  enableProdMode();
}

import { routes } from './app/app-routing.module';

bootstrapApplication(AppComponent, {
  providers: [
    SplashScreen,
    StatusBar,
    provideRouter(routes),
    provideIonicAngular(),
    provideAnimations()
  ]
})
  .catch(err => console.log(err));
